module.exports = __webpack_public_path__ + "ENG_SPS9-ArtSupplies-2923f92c183ae1de7d49f5d30b923e9c.png";